import React, { ReactNode, useState, useEffect } from 'react';
import { Button } from 'antd';
import { RootState } from '../../redux/store';
import { useSelector } from 'react-redux';
import { showMsg, transCockpitWorkTime } from '@/utils/util';
import './index.scss';
import { CockpitMode, CockpitStatus } from '@/utils/constant';
import { request } from '@/fetch/core';
import { HttpStatusCode } from '@/fetch/core/constant';

export const Vertical = ({
  value,
  label,
}: {
  value: string | number | ReactNode;
  label: string | ReactNode;
}) => {
  return (
    <div className='vertical-container'>
      <p className='value'>{value || '--'}</p>
      <p className='label'>{label}</p>
    </div>
  );
};

export const Avatar = ({
  title,
  imgUrl,
  iconTitle,
}: {
  imgUrl: string;
  title?: string;
  iconTitle?: string;
}) => {
  return (
    <div className='avatar-conatiner'>
      <img src={imgUrl}></img>
      {iconTitle && <div className='icon'>{iconTitle}</div>}
      {title && <p className='title'>{title}</p>}
    </div>
  );
};

export const Board = ({
  title,
  imgUrl,
  iconTitle,
  options,
}: {
  title: string;
  imgUrl: string;
  iconTitle: string;
  options: {
    label: string;
    value: string | number;
  }[];
}) => {
  return (
    <div className='cockpit-board-conatiner'>
      <Avatar title={title} imgUrl={imgUrl} iconTitle={iconTitle} />
      {options.map((item, index) => {
        return <Vertical value={item.value} label={item.label} key={index} />;
      })}
    </div>
  );
};
const CockpitBoardHeader = () => {
  const { currentCockpit, cockpitStatus, cockpitTeamNumber } = useSelector(
    (state: RootState) => state.cockpitInfo,
  );
  const { userName } = useSelector((state: RootState) => state.login);
  const [totalWorkTime, setTotalWorkTime] = useState<string>('');
  const [cockpitTeamInfo, setCockpitTeamInfo] = useState<any>();
  const now = new Date().getTime();
  useEffect(() => {
    if (
      currentCockpit.cockpitMode &&
      currentCockpit.cockpitMode !== CockpitMode.MONITOR
    ) {
      setCockpitTeamInfo({ ...currentCockpit });
    } else {
      cockpitTeamNumber && fetchCockpitTeamInfo();
    }
  }, [
    currentCockpit.individualStartTime,
    currentCockpit.individualWorkTime,
    cockpitTeamNumber,
  ]);

  useEffect(() => {
    let timeInterval: any = null;
    calculateWorkTime();
    timeInterval = setInterval(() => {
      calculateWorkTime();
    }, 60000);
    return () => {
      clearInterval(timeInterval);
    };
  }, [now]);

  const calculateWorkTime = () => {
    let _totalWorkTime = '';
    if (
      cockpitStatus === CockpitStatus.WORK &&
      cockpitTeamInfo?.individualStartTime
    ) {
      _totalWorkTime = transCockpitWorkTime(
        now -
          cockpitTeamInfo?.individualStartTime +
          cockpitTeamInfo?.individualWorkTime,
      );
    } else {
      _totalWorkTime = transCockpitWorkTime(
        cockpitTeamInfo?.individualWorkTime,
      );
    }
    setTotalWorkTime(_totalWorkTime);
  };

  const fetchCockpitTeamInfo = async () => {
    try {
      const res = await request({
        path: '/monitor/web/cockpitTeam/getTeamManagerStatistic',
        body: {
          cockpitTeamNumber: cockpitTeamNumber,
        },
        method: 'POST',
      });
      if (res.code === HttpStatusCode.Success) {
        setCockpitTeamInfo({
          cockpitNumber: '',
          teamTotalNum: res.data.completeIssueCount,
          teamPendingNum: res.data.waitAcceptIssueCount,
          cockpitTeamNumber: res.data.cockpitTeamNumber,
          cockpitTeamName: res.data.cockpitTeamName,
          individualTotalNum: res.data.managerInfo.completeIssueCount,
          individualWorkTime: res.data.managerInfo.workTimeTotal * 1000, // 时间戳
          individualStartTime: null, // 时间戳
        });
      } else {
        showMsg({
          msg: res.message,
          type: 'error',
        });
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className='cockpit-board-header'>
      <Board
        title={cockpitTeamInfo?.cockpitTeamName}
        imgUrl={require('../../assets/img/cockpit/team_avatar.png')}
        iconTitle='团队'
        options={[
          {
            value: cockpitTeamInfo?.teamTotalNum,
            label: '今日处理工单总数',
          },
          {
            value: cockpitTeamInfo?.teamPendingNum,
            label: '待处理工单数',
          },
        ]}
      />

      <Board
        title={userName}
        imgUrl={require('../../assets/img/cockpit/individual_avatar.png')}
        iconTitle='个人'
        options={[
          {
            value: cockpitTeamInfo?.individualTotalNum,
            label: '今日工单处理数量',
          },
          {
            value: totalWorkTime,
            label: '今日工作时长',
          },
        ]}
      />
    </div>
  );
};

export default React.memo(CockpitBoardHeader);
